import Vue from "vue";
import VueResource from "vue-resource";

import { API_ROOT, API_ACTIVITY_ROOT, studies, participants, activities, variable, variables, variablebyfilter, studyManagement, responsemanagement, grouptags, revision, queryTool, activity, activityRevisionId, study } from "./urls";

Vue.use(VueResource);

const createVariableResource = Vue.resource(`${API_ROOT}${studyManagement}${activities}{/activityId}${revision}{activityRevisionId}/${variable}`);
const updateVariableResource = Vue.resource(`${API_ROOT}${studyManagement}${activities}{/activityId}${revision}{activityRevisionId}/${variable}{/variableId}`);
const getAllVariableResource = Vue.resource(`${API_ROOT}${studyManagement}${activities}{/activityRevisionId}/${variables}`);
const getVariableByFilter = Vue.resource(`${API_ROOT}${studyManagement}${activities}{/activityRevisionId}/${variablebyfilter}`);
const getVariableDetailResource = Vue.resource(`${API_ROOT}${studyManagement}${activities}${revision}{activityRevisionId}/${variable}{/variableId}`);
const getVariablesScoresResource = Vue.resource(`${API_ROOT}${responsemanagement}${studies}{/studyId}/${participants}{/participantId}/${activities}{/activityId}${revision}{activityRevisionId}/scores`);
const deleteVariableResource = Vue.resource(`${API_ROOT}${studyManagement}${activities}{/activityRevisionId}/${variable}{/variableId}`);
const getActivityRevisionIdResource = Vue.resource(`${API_ROOT}${queryTool}/${study}{/studyId}/${activityRevisionId}`);
const getAllGroupTagResource = Vue.resource(`${API_ACTIVITY_ROOT}${activity}/${activities}{/activityRevisionId}/${grouptags}`);

export function createVariable(pathParams, data) {
  return createVariableResource.save(pathParams, data);
}

export function updateVariable(pathParams, data) {
  return updateVariableResource.update(pathParams, data);
}

export function getAllVariables(pathParams, queryParams = {}) {
  return getAllVariableResource.get({ ...pathParams, ...queryParams });
}
export function getAllGroupTags(pathParams) {
  return getAllGroupTagResource.get(pathParams);
}

export function getVariableDetails(pathParams) {
  return getVariableDetailResource.get(pathParams);
}

export function getFilterVariableDetails(pathParams, queryParams = {}) {
  return getVariableByFilter.get({ ...pathParams, ...queryParams });
}

export function deleteVariable(pathParams) {
  return deleteVariableResource.delete(pathParams);
}

export function getVariablesScores(pathParams, queryParams = {}) {
  return getVariablesScoresResource.get({ ...pathParams, ...queryParams });
}

export function getActivityRevisionId(pathParams, queryParams = {}) {
  return getActivityRevisionIdResource.get({ ...pathParams, ...queryParams });
}
